import { HttpClient } from '@adapters/HttpClient';
import { RelocationListFilters, RelocationModel } from '../models/Relocation';

export interface RelocationsPage {
  relocations: RelocationModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

interface RelocationsApiResponse {
  data: RelocationModel[];
  meta: {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
  };
}

interface CreateRelocationPayload {
  cart_id: number;
  notes?: string;
}

interface CreateRelocationResponse {
  id: number;
}

export class RelocationsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Lista paginada de reubicaciones (GET /relocations).
   * Filtros: status, cart_id, date_from, date_to, page.
   */
  async getRelocationsPaginated(filters: RelocationListFilters = {}): Promise<RelocationsPage> {
    const { status, cart_id, date_from, date_to, page = 1 } = filters;

    const params: Record<string, string | number> = { page };
    if (status) params.status = status;
    if (cart_id !== undefined && !Number.isNaN(cart_id)) params.cart_id = cart_id;
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;

    const showGlobalLoading = page === 1;
    const response = await this.httpClient.get<RelocationsApiResponse>('/relocations', params, {}, showGlobalLoading);

    const { currentPage, lastPage } = response.meta;
    return {
      relocations: response.data,
      nextPage: currentPage < lastPage ? currentPage + 1 : undefined,
      hasMore: currentPage < lastPage,
      total: response.meta.total,
    };
  }

  /** Crea una nueva reubicación (POST /relocations) y retorna su id */
  async createRelocation(payload: CreateRelocationPayload): Promise<CreateRelocationResponse> {
    return this.httpClient.post<CreateRelocationResponse>('/relocations', payload);
  }
}
